/**
 * The boot splash (#boot-splash in public/index.html) sits outside #root, above
 * everything, so React never tears it down mid-paint. It's removed only once the
 * app has something equivalent on screen:
 *  - a <Loader> whose logo has decoded (it calls hideBootSplash itself), or
 *  - the app's first real content, when no Loader is mounted (see App.tsx).
 * Swapping earlier leaves a frame where the Loader's logo isn't painted yet —
 * a visible flicker on slow networks.
 */
export const LOADER_ATTR = 'data-app-loader';

export function hideBootSplash(): void {
  document.getElementById('boot-splash')?.remove();
}

export function hideBootSplashIfNoLoader(): void {
  requestAnimationFrame(() => requestAnimationFrame(() => {
    if (!document.querySelector(`[${LOADER_ATTR}]`)) hideBootSplash();
  }));
}
